import React from 'react';
import {compare_palette, getInterpolatedColor} from "../../components/color/Palettes";


export function Comparison({children, index}) {


    return (
        <div className={"comparison rounded-4 border d-flex flex-column align-content-start shadow my-3"} >

            <div className={" text-white rounded-top p-3 "} style={{backgroundColor:getInterpolatedColor(compare_palette, index, 0, 10)}}>
                {children[0]}
            </div>

            <div className={"p-2"}>
                {
                    children.slice(1).map((child, i) => (
                        <div className={""} >
                            {child}
                        </div>
                    ))
                }

            </div>


        </div>
    )

}